import React,{ useEffect, useState } from 'react';
import {Page} from 'react-weui';
import styles from './styles.scss';
import { history } from 'umi';
import {getCommentDetail,commentReply,commentDelete,replyCommentDelete,commentLike} from '@/services/course';

import { Toast } from 'antd-mobile';
import { getLoginUser } from '@/utils/login';




export default (props) => {

  const comment = props.location.state.comment;
  const [commentDetail, setCommentDetail] = useState(comment);

  const [commentText, setCommentText] = useState('');

  const loginUser = getLoginUser();

  useEffect(()=>{
    getDetail();
  },[]);


  function getDetail() {
    Toast.loading('loading',60);
    getCommentDetail({id:comment.id}).then(res => {
      console.log(res);
      Toast.hide();
      if (res && res.code == 200) {
        setCommentDetail(res.data);
      }else {
        Toast.fail(res.message,1);
      }
    }).catch(e => {
      Toast.hide();
      Toast.fail('评论加载失败，请重试',1);
    });
  }

  function likeComment(comment){
    Toast.loading('loading...',60);
    commentLike({commentId:comment.id}).then(res => {
      Toast.hide();
      if (res.code == 200) {

        getDetail();
      } else {
        Toast.fail(res.message,1);
      }
    }).catch(e =>{
      Toast.hide();
      Toast.fail('点赞失败，请重试',1);
    })
  }

  function deleteComment(comment) {
    Toast.loading('删除中...',60);
    commentDelete({id:comment.id}).then(res => {
      Toast.hide();
      if (res.code == 200) {
        history.goBack();
      } else {
        Toast.fail(res.message,1);
      }
    }).catch(e =>{
      Toast.hide();
      Toast.fail('删除失败，请重试',1);
    })
  }

  function deleteReply(reply) {
    Toast.loading('删除中...',60);
    replyCommentDelete({id:reply.id}).then(res => {
      Toast.hide();
      if (res.code == 200) {
        getDetail();
      } else {
        Toast.fail(res.message,1);
      }
    }).catch(e =>{
      Toast.hide();
      Toast.fail('删除失败，请重试',1);
    })
  }

  return (
    <Page transition={true} infiniteLoader={false} ptr={false}>
      <div className={styles.tabCenter}>
        <div className={styles.commentItem}>
          <img
            className={styles.commentHead}
            src={
              commentDetail.member && commentDetail.member.avatarurl ?  commentDetail.member.avatarurl : require('@/assets/notify.png')
            }
          />

          <div className={styles.commentContent}>
            <div
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <label className={styles.commentUser}>
                {commentDetail.member && commentDetail.member.nickname ? commentDetail.member.nickname : ''}
              </label>

              {loginUser && loginUser.id == commentDetail.memberId && (
                <div
                  className={styles.delButton}
                  onClick={() => {
                    deleteComment(commentDetail);
                  }}
                >
                  <img src={require('@/assets/close.png')} />
                </div>
              )}
            </div>

            <label className={styles.commentMsg}>{commentDetail.content}</label>

            <div className={styles.commentBottom}>
              <label className={styles.commentTime}>
                {commentDetail.createDate}
              </label>

              <img
                src={
                  commentDetail.isLike == '0'
                    ? require('@/assets/ic_like.png')
                    : require('@/assets/ic_liked.png')
                }
                onClick={() => {
                  likeComment(commentDetail);
                }}
              />
              <label
                style={{
                  color: commentDetail.isLike == '0' ? '#666' : '#57B99D',
                }}
              >
                {commentDetail.likeCount}
              </label>
            </div>
          </div>
        </div>

        {commentDetail.memberCourseCommentReplyList.map((item, index) => (
          <div className={styles.detailReplyItem} key={item.id}>
            <div className={styles.h_box}>
              <label className={styles.detailCommentUser}>
                {item.member.nickname}
              </label>

              {loginUser && loginUser.id == item.memberId && (
                <div
                  className={styles.delButton}
                  onClick={() => {
                    deleteReply(item);
                  }}
                >
                  <img src={require('@/assets/close.png')} />
                </div>
              )}

              <label className={styles.detailCommentTime}>
                {item.createDate}
              </label>
            </div>

            <div className={styles.h_box} style={{ marginTop: '10px' }}>
              <label className={styles.detailReplyUser}>
                @{item.replyMember.nickname}：
              </label>
              <label className={styles.detailReplyMsg}>{item.content}</label>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.bottomBar}>
        <textarea
          className={styles.commentInput}
          type="search"
          value={commentText}
          placeholder={'请输入评论'}
          onChange={e => {
            setCommentText(e.target.value);
          }}
        />

        <div
          className={styles.commentSend}
          onClick={() => {
            submitReplyComment();
          }}
        >
          发送
        </div>
      </div>
    </Page>
  );


  function submitReplyComment() {
    Toast.loading('正在发送...',60);
    commentReply({commentId:comment.id,content:commentText,replyMemberId:comment.memberId}).then(res => {
      Toast.hide();
      if (res.code == 200) {
        setCommentText('');
        getDetail();
      } else {
        Toast.fail(res.message,1);
      }
    }).catch(e =>{
      Toast.hide();
      Toast.fail('回复失败，请重试',1);
    })
  }

}


